<template>
  <BaseForm
    class="registry-slide-form"
    :action="action"
    :response-to="responseTo"
    :response-text="responseText"
    gtm-submit-event="form_submit_registry"
  >
    <template #fields>
      <NameField
        class="rounded-0"
        :outlined="false"
        height="48px"
        hide-details
        solo
        flat
      />
      <TelField
        class="rounded-0"
        :outlined="false"
        height="48px"
        hide-details
        solo
        flat
      />
      <EmailField
        class="rounded-0"
        :outlined="false"
        height="48px"
        hide-details
        solo
        flat
      />
      <PolicyPrivacyField
        class="mb-4"
        :outlined="false"
        hide-details
        solo
        flat
        dark
      />
    </template>

    <template #button>
      <ButtonWidget type="submit" block>
        <v-icon color="white" size="16" left> fas fa-paper-plane </v-icon>
        Enviar
      </ButtonWidget>
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import TelField from "./fields/TelField.vue";
import EmailField from "./fields/EmailField.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    responseTo: String,
    responseText: String,
  },
  components: {
    BaseForm,
    NameField,
    TelField,
    EmailField,
    PolicyPrivacyField,
    ButtonWidget,
  },
};
</script>

<style lang="scss">
.registry-slide-form {
  .base-form-fields {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
